// @flow

import React from 'react';
import Tappable from 'app/components/commons/Tappable';
import classNames from 'classnames';
import colorUtils from 'color';
import useSheet from 'app/jss';
import Avatar from 'app/components/commons/Avatar';
import { FRIEND, FRIEND_REQUESTS, NOT_FRIEND } from 'app/constants/friendStatusTypes';

type Props = {
  avatar?: Object,
  disabled?: boolean,
  username: string,
  sheet: Object,
  status?: number,
  onClick: (id: number) => void,
};

type State = {};

const defaultProps = {
  avatar: undefined,
  disabled: false,
  status: undefined, // a user from search results has no status
};

class FriendCompactDetails extends React.Component {
  props: Props;
  state: State;

  render() {
    const { avatar, disabled, username, onClick, sheet: { classes }, status } = this.props;

    return (
      <Tappable
        className={classNames(classes.content, {
          friend: status === FRIEND,
          request: FRIEND_REQUESTS.includes(status),
          'not-friend': status === NOT_FRIEND,
          disabled,
        })}
        onTap={onClick}
        stopPropagation
        style={{ cursor: disabled ? 'default' : 'pointer' }} // override Tappable cursor's inline style
      >
        <Avatar size="small" avatar={avatar} status={status} hasWhiteBackground />
        <span className={classes.username}>{username}</span>
      </Tappable>
    );
  }
}

FriendCompactDetails.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    content: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      height: '100%',
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'background-color 0.2s, opacity 0.2s',
      '&.request:not(.disabled)': {
        backgroundColor: theme.color.white,
      },
      '&.friend:not(.disabled)': {
        backgroundColor: theme.color.white,
      },
      '&.not-friend:not(.disabled)': {
        backgroundColor: theme.color.basis6,
      },
      '&.disabled': {
        cursor: 'not-allowed !important',
        backgroundColor: colorUtils(theme.color.basis6)
          .alpha(0.8)
          .string(),
        opacity: 0.7,
      },
    },
    username: {
      fontSize: theme.fontSize.xxsmall,
      textOverflow: 'ellipsis',
      maxWidth: '90%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      marginTop: 5,
    },
  };
}

export default useSheet(applyStyles)(FriendCompactDetails);
